import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  formDataPostRequest,
  formDataPutRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getAll(gridData) {
  const orderBy = gridData.orderBy ? gridData.orderBy : "Id desc";
  return getRequest(
    `Company?pageNumber=${gridData.pageNumber}&pageSize=${gridData.length}&orderBy=${orderBy}&filterExpression=${gridData.filterExpression}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getById(id) {
  return getRequest(`Company/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllList() {
  return getRequest(`Company/list`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteById(id) {
  return deleteRequest(`Company/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function create(data) {
  return formDataPostRequest(`Company/Create`, data, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function update(data) {
  return formDataPutRequest(`Company`, data, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllPlatformCompanies(gridData) {
  const orderBy = gridData.orderBy ? gridData.orderBy : "Id desc";
  return getRequest(
    `Company/getAllPlatformCompanies?pageNumber=${gridData.pageNumber}&pageSize=${gridData.length}&orderBy=${orderBy}&filterExpression=${gridData.filterExpression}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updatePlatformCompany(data) {
  return putRequest(`Company/updatePlatformCompany`, data, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getPlatformCompanyById(id) {
  return getRequest(`Company/platformCompany/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deletePlatformCompanyById(id) {
  return deleteRequest(`Company/deletePlatformCompany/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const companyService = {
  getAll,
  getById,
  deleteById,
  create,
  update,
  getAllList,
  getAllPlatformCompanies,
  updatePlatformCompany,
  getPlatformCompanyById,
  deletePlatformCompanyById,
};
